module.exports = new __parcel__URL__("news08.2c3c08c2.jpg").toString();